import { CandidateApplication } from "./candidate_application";

export class CandidateApplications extends Array<CandidateApplication> {
  constructor(candidateApplications?: CandidateApplication[]) {
    super();
    if (candidateApplications instanceof Array) {
      candidateApplications.forEach((candidateApplication) =>
        this.push(candidateApplication),
      );
    }
  }
}
